import React from "react";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <div className="min-h-[560px] lg:h-[800px] py-12 lg:py-0 bg-cover bg-center homepageBanner flex items-center">
      <div
        className="container relative mx-auto grid h-full w-full max-w-none items-center bg-cover bg-center"
        style={{
          backgroundImage:
            "linear-gradient(rgba(26, 36, 58, 0.86), rgba(26, 36, 58, 0.86)), url('/theroyalcourtofjustice.png')",
        }}
      >
        <div className="px-12">
          <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6 lg:w-2/3">
            Protecting <br /> what matters <span className="italic font-serif font-normal text-[#C9A04A]">helping</span><br /> you move forward
          </h1>
          <p className="text-base md:text-lg lg:text-xl text-white/85 max-w-2xl leading-relaxed text-justify">
            Blackhorse Law provides tailored legal advice and dedicated representation in immigration and family law. From building your future in the UK to navigating sensitive family matters, we help you understand your options and take your next steps with confidence. With careful preparation, clear communication and personal attention, we put your needs at the heart of every case.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a
              href="#offices"
              onClick={(e) => {
                const target = document.getElementById("offices");
                if (target) {
                  e.preventDefault();
                  target.scrollIntoView({ behavior: "smooth" });
                  window.history.pushState(null, "", "#offices");
                }
              }}
              className="inline-flex items-center gap-2.5 rounded-full bg-[#C9A04A] px-6 py-3.5 text-sm sm:text-base font-semibold text-white shadow-md transition duration-200 hover:bg-[#b58f3e]"
            >
              <span>Free Assessment</span>
              <svg
                className="h-4 w-4 shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </a>

            <Link
              to="/contact"
              className="inline-flex items-center gap-2.5 rounded-full border border-white/50 px-6 py-3.5 text-sm sm:text-base font-semibold text-white transition duration-200 hover:border-white hover:bg-white/10"
            >
              <span>Contact us</span>
              <svg
                className="h-4 w-4 shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </Link>
          </div>
        </div>

        {/* <div className="absolute bottom-8 right-4 lg:bottom-24 lg:right-0 bg-white/80 p-6 lg:p-10 lg:w-[580px]">
          <p className="text-sm lg:text-base mb-4">
            If you're looking for legal support from the best full-service legal
            practice, get in touch to learn how we can help you
          </p>
          <a
            href="#contact"
            className="flex items-center gap-2 text-purple font-semibold hover:opacity-80"
          >
            <span>Get in touch</span>
            <span className="bg-purple text-white px-2 py-1">→</span>
          </a>
        </div> */}
      </div>
    </div>
  );
};

export default Hero;
